import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { observable } from 'mobx';

import { Table, DateValue, Column, Button, Pager } from '@smartplatform/ui';
import store from '../../store';

const PER_PAGE = 20;

@withRouter @observer
export default class List extends React.Component {
	
	@observable records = [];
	@observable isLoading = true;
	@observable page = 1;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.isLoading = true;
		this.records = await store.model.Session.find({
			limit: PER_PAGE,
			skip: (this.page - 1) * PER_PAGE,
			order: 'id desc',
		});
		this.isLoading = false;
	};
	
	onPageChange = page => {
		this.page = page;
		this.init();
	};
	
	render() {
		return <>
			<p>Заседания</p>
			<Pager
				current={this.page}
				onChange={this.onPageChange}
				totalCount={this.records.totalCount}
			/>
			{this.records.length > 0 &&
				<Table records={this.records} rootPath="/admin" path="voting">
					<Column width={60} property="id" label="ID"/>
					<Column property="name" label="Наименование" />
					<Column width={80} property="registrationStart" label="Начало регистрации"><DateValue format="DD.MM.YYYY" /></Column>
				</Table>
			}
		</>;
	}
	
}
